import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentJointCreatePasskeyData,
  type EnrollmentJointCreatePasskeySubmitOutput,
  type GetJointEnrollmentPasskeyOptionsOutput,
  AccountRecoveryStatus,
} from '../../../../models'

export const getEnrollmentJointCreatePasskeyDataMock: EnrollmentJointCreatePasskeyData = {
  errors: [],
  isError: false,
  activePerson: {
    applicationId: '305802305',
    path: '/enrollment/joint/create-passkey',
  },
}

export const submitEnrollmentJointCreatePasskeyDataMock: EnrollmentJointCreatePasskeySubmitOutput = {
  errors: [],
  isError: false,
  activePerson: {
    path: '/enrollment/joint/disclosures',
  },
}

export const getJointEnrollmentPasskeyOptionsMock: GetJointEnrollmentPasskeyOptionsOutput = {
  __typename: 'AccountRecoveryResponse',
  publicKeyCredentialCreationOptions: JSON.stringify({
    rp: { name: 'Evergreen Wealth', id: 'localhost' },
    user: {
      name: 'nick+wh@evergreen.money',
      displayName: 'Nick Navarro',
      id: 'dXNlci0wOTU3YTZjOC1iZmY1LTQ3ZDctYTMwMC05MWI4NjAwNWE4YWQ',
    },
    challenge: '1riMFgLYB9oUt5qtChOAuL-BL9hs_U6myyI5Qov9Mh4',
    pubKeyCredParams: [
      { alg: -7, type: 'public-key' },
      { alg: -8, type: 'public-key' },
      { alg: -35, type: 'public-key' },
      { alg: -36, type: 'public-key' },
      { alg: -257, type: 'public-key' },
      { alg: -258, type: 'public-key' },
      { alg: -259, type: 'public-key' },
    ],
    excludeCredentials: [],
    authenticatorSelection: {
      requireResidentKey: false,
      residentKey: 'preferred',
      userVerification: 'preferred',
    },
    attestation: 'direct',
    extensions: { credProps: true },
  }),
  status: AccountRecoveryStatus.REGISTER_WEBAUTHN,
}

export const mockGetEnrollmentJointCreatePasskeyData = graphql.mutation('getEnrollmentJointCreatePasskeyData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointCreatePasskeyDataMock } })
})

export const mockSubmitEnrollmentJointCreatePasskeyData = graphql.mutation(
  'submitEnrollmentJointCreatePasskeyData',
  () => {
    return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointCreatePasskeyDataMock } })
  },
)

export const mockGetJointEnrollmentPasskeyOptions = graphql.mutation('accountRecovery', () => {
  return HttpResponse.json({ data: { accountRecovery: getJointEnrollmentPasskeyOptionsMock } })
})

export const mockEnrollmentJointCreatePasskey = [
  mockGetEnrollmentJointCreatePasskeyData,
  mockSubmitEnrollmentJointCreatePasskeyData,
  mockGetJointEnrollmentPasskeyOptions,
]
